export const precos = [    
    {name: "Treino Avulso", price:"15"},
    {name: "MENSAL", price:"90"},
    {name: "TRIMESTRAL", price:"180"},
    {name: "SEMESTRAL", price:"370"},
    {name: "ANUAL", price:"680"}
]